import React from "react";
import styles from "Styles/components/RadioGroup.module.css";
import pillStyles from "Styles/Inputs.module.css";

export default function RadioGroup({
  IDRoot = "radio-input",
  radioData = [],
  handleChange,
  selectedValue,
  name = "radio",
  variant = "default",
}) {
  const renderLabel = (label) => {
    if (typeof label === "string" && label.includes("**")) {
      const parts = label.split(/(\*\*.*?\*\*)/g);
      return parts.map((part, i) => {
        if (part.startsWith("**") && part.endsWith("**")) {
          return <strong key={i}>{part.slice(2, -2)}</strong>;
        }
        return <span key={i}>{part}</span>;
      });
    }
    return label;
  };

  if (variant === "pill") {
    return (
      <div className={pillStyles.radioGroupWrapper}>
        {radioData.length > 0 &&
          radioData.map((radio, index) => {
            const value = radio.value || radio.label;
            const label = radio.label;
            const isChecked = selectedValue === value;

            return (
              <React.Fragment key={index}>
                <input
                  id={`${IDRoot}-${index}`}
                  type="radio"
                  name={name}
                  value={value}
                  className={pillStyles.inputElement}
                  checked={isChecked}
                  onChange={() => handleChange(value)}
                />
                <label
                  className={pillStyles.inputLabel}
                  htmlFor={`${IDRoot}-${index}`}
                >
                  {label}
                </label>
              </React.Fragment>
            );
          })}
      </div>
    );
  }

  return (
    <div className={styles.radioGroupWrapper}>
      {radioData.length > 0 &&
        radioData.map((radio, index) => {
          const value = radio.value || radio.label;
          const label = radio.label;
          const isChecked = selectedValue === value;

          return (
            <label
              key={index}
              className={`${styles.radioItem} ${isChecked ? styles.checked : ""}`}
              htmlFor={`${IDRoot}-${index}`}
            >
              <input
                id={`${IDRoot}-${index}`}
                type="radio"
                name={name}
                value={value}
                className={styles.radioInput}
                checked={isChecked}
                onChange={() => handleChange(value)}
              />
              <span className={styles.radioCircle} />
              <span className={styles.radioLabel}>{renderLabel(label)}</span>
            </label>
          );
        })}
    </div>
  );
}
